import React from 'react';
import { StyleSheet } from 'react-native';
import { BodyText, DisplayText, theme, useResponsive } from '@sg/garnish';

export const ChallengesScreenSectionHeader: React.FC = (props) => {
  const { currentBreakpoint } = useResponsive();

  const testID = 'challenges.screen-header';

  if (currentBreakpoint.isMobile)
    return (
      <BodyText size={2} style={styles.sectionHeaderXS} testID={testID}>
        {props.children}
      </BodyText>
    );

  return (
    <DisplayText size={3} testID={testID}>
      {props.children}
    </DisplayText>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  sectionHeaderXS: {
    paddingBottom: theme.spacing.small,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.GRAY,
  },
});
